<script>
  import MyAppsListItem from './MyAppsListItem'

  export default {
    name: 'my-apps-list',

    components: {
      MyAppsListItem
    },

    props: {
      apps: {
        type: Array,
        required: true
      }
    }
  }
</script>

<template>
  <table class="table table-hive">
    <thead>
    <tr>
      <th scope="col" style="width: 75%;"></th>
      <th scope="col"></th>
      <th scope="col"></th>
    </tr>
    </thead>
    <transition-group name="list" tag="tbody">
      <my-apps-list-item v-for="app in apps" :key="app.applicationId" :app="app"/>
    </transition-group>
  </table>
</template>
